import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';

import { StickyFooterComponent } from './sticky-footer.component';

@NgModule({
	declarations: [StickyFooterComponent],
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		AnalyticsModule
	],
	exports: [StickyFooterComponent]
})
export class StickyFooterModule {
	
}
